import * as React from "react";
import type { GlobalProvider } from "@ladle/react";
import "./styles.css";

export const Provider: GlobalProvider = ({ children, globalState, storyMeta }) => <>{children}</>;
